/* src/app/modules/home/components/documents/documents.component.scss */
.questionary-actions p {
  margin: 1.25rem 8%;
  font-size: 1.125rem;
}
.questionary-actions .center-container {
  padding-top: 1.25rem;
  text-align: center;
}
.questionary-actions .center-container .upload {
  display: inline-block;
  cursor: pointer;
  position: relative;
}
.questionary-actions .center-container .upload-hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
}
.questionary-actions .center-container .upload .explanatory {
  text-transform: none;
  font-size: 0.75rem;
  color: var(--negative-3);
  position: absolute;
  width: 15.625rem;
  left: 0%;
  top: 3.438rem;
}
.questionary-actions .center-container .upload .error {
  text-align: left;
  width: 100%;
  text-transform: none;
  color: var(--negative-3);
}
.questionary-actions .center-container ods-button {
  display: inline-block;
  margin-left: 3.75rem;
  vertical-align: top;
  height: 3.125rem;
}
.questionary-actions .center-container ods-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  height: 1.7rem;
  width: 1.7rem;
  margin: 0.5rem;
}
.upload:focus-within {
  outline: 2px solid var(--brand-50);
  outline-offset: 3px;
}
/*# sourceMappingURL=documents.component.css.map */
